module.exports = __webpack_public_path__ + "img/bonus5.913d4446.png";